import {getParameterByName} from '../utils/tools';
let init = false;
let homeworkInfo = {
    userId: '',
    homeworkId: '',
    unitId: '',
    courseId: '',
    lessonId: '',
    classId: '',
    className: '',
    sectionId: '',
    title: '',
    projectUrl: '',
    projectAnswerUrl: ''

};
const initHomeworkInfo = () => {
    homeworkInfo = Object.assign({}, homeworkInfo, {
        projectUrl: getParameterByName('url'),
        homeworkId: getParameterByName('homeworkId'),
        title: getParameterByName('title'),
        courseId: getParameterByName('courseId'),
        classId: getParameterByName('classId'),
        className: getParameterByName('className'),
        unitId: getParameterByName('unitId'),
        lessonId: getParameterByName('lessonId'),
        sectionId: getParameterByName('sectionId'),
        userId: getParameterByName('userId')
    });
    localStorage.setItem('homeworkInfo', JSON.stringify(homeworkInfo));
};
const setHomeworkInfo = newHomeworkInfo => {
    homeworkInfo = Object.assign({}, homeworkInfo, newHomeworkInfo);
    localStorage.setItem('homeworkInfo', JSON.stringify(homeworkInfo));
};
const getHomeworkInfo = () => {
    if (!init) {
        init = true;
        initHomeworkInfo();
    }
    return homeworkInfo;
};

export {
    getHomeworkInfo,
    setHomeworkInfo
};
